import { isHomsAppType } from "./homsModuleConfigurationUtils";
import { excludeHposOriginOrders, isHposOriginOrder } from "./orderUtils";

const getStore = () => require("../Redux/store").default;

export function isHomsSession() {
  try {
    const appType = getStore()?.getState()?.globalState?.appType;
    return isHomsAppType(String(appType || "").trim());
  } catch {
    return false;
  }
}

/** HOMS working lists never include till tickets. HPOS / other apps keep them. */
export function scopeOrdersForCurrentApp(orders) {
  const list = Array.isArray(orders) ? orders : [];
  return isHomsSession() ? excludeHposOriginOrders(list) : list;
}

export function shouldHideOrderFromHoms(order) {
  return isHomsSession() && isHposOriginOrder(order);
}

export function homsVisibleOrders(orders, appType) {
  if (!isHomsAppType(String(appType || "").trim())) {
    return Array.isArray(orders) ? orders : [];
  }
  return excludeHposOriginOrders(orders);
}
